import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import SeoHreflang from '../components/SeoHreflang';
import logo_rus from '../assets/logo_rus.png';
import logo_eng from '../assets/logo_eng.png';
import logo_esp from '../assets/logo_esp.png';
import logo_zh from '../assets/logo_zh.png';
import i18n from "../i18n";
import { Link } from "react-router-dom";
import SiteHeader from '../components/SiteHeader';
import '..//components/Video.css';
import VideoPlayer from '..//components/VideoPlayer';
import '..//components/VideoPlayer.css';
import learningVideo from '..//assets/learning_video.mp4';
import learningVideo_foreign from '..//assets/learning_video_foreign.mp4';
import aboutImg from '..//assets/about-img.jpg';


const LanguageSwitcher = React.lazy(() => import('..//components/LanguageSwitcher'));


// CoursesLanding.jsx — React + Tailwind, однофайловый лендинг «Обучающие курсы»
// Переносит структуру исходной HTML‑страницы в компонент без внешних CSS.

export default function CoursesPage() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <SeoHreflang />
      <Header />
      <Hero />
      <Container>
        <div className='w-full items-center justify-center m-auto'>
            <VideoPlayer videoMaterial={lang === 'ru' ? learningVideo : learningVideo_foreign}/>
        </div>
      </Container>
      <Proof />
      <Benefits />
      <Program />
      <ActionBlock />
      <Instructor />
      <Testimonials />
      <Pricing />
      <CtaBar />
      <Faq />
      <Footer year={year} />
    </div>
  );
}

/* ===================== UI PRIMITIVES ===================== */
function Container({ className = "", children }) {
  return (
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
  );
}

function Card({ className = "", children }) {
  return (
    <div className={`rounded-3xl border border-gray-200 bg-white p-6 ${className}`}>{children}</div>
  );
}

function Pill({ children, className = "" }) {
  return (
    <div
      className={`rounded-2xl text-white p-5 ${className}`}
      style={{ background: "linear-gradient(90deg,#7c3aed,#4f46e5)" }}
    >
      {children}
    </div>
  );
}

function CheckIcon({ className = "h-4 w-4 text-green-600" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-2.59a.75.75 0 10-1.22-.88l-3.26 4.52-1.51-1.51a.75.75 0 10-1.06 1.06l2.19 2.19c.33.33.86.28 1.13-.11l3.73-5.27z" clipRule="evenodd" />
    </svg>
  );
}

function Li({ children }) {
  return (
    <li className="flex items-start gap-2"><CheckIcon /><span>{children}</span></li>
  );
}




/* ===================== HEADER ===================== */
function Header() {
  const logoMap = { ru: logo_rus, en: logo_eng, es: logo_esp, zh: logo_zh };
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const currentLogo = logoMap[lang] || logo_eng;
  const { t } = useTranslation();
  return (
<SiteHeader
  pageLinks={[
    { label: t('linkOLBP1'), href: '#program' },
    { label: t('linkOLBP2'), href: '#benefits' },
    { label: t('linkOLBP3'), href: '#proof' },
    { label: t('linkOLBP4'), href: '#pricing' },
    { label: t('linkMP5'),   href: '#faq' },
  ]}
  cta={[{ label: t('ButtonOLBP1'), to: 'https://best-practices.zenclass.ru/school/products' }]}
/>

    // <header className="sticky top-0 z-40 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-gray-100">
    //   <Container className="h-16 flex items-center justify-between">
    //     <Link to="/" style={{height: '100%'}}>
    //           <img src={currentLogo} style={{ height: '100%', width: 'auto' }} alt="logo"/>
    //     </Link>
    //     <nav className="hidden md:flex items-center gap-6 text-sm">
    //       <a href="#program" className="hover:text-purple-600">{t('linkOLBP1')}</a>
    //       <a href="#benefits" className="hover:text-purple-600">{t('linkOLBP2')}</a>
    //       <a href="#proof" className="hover:text-purple-600">{t('linkOLBP3')}</a>
    //       <a href="#pricing" className="hover:text-purple-600">{t('linkOLBP4')}</a>
    //       <a href="#faq" className="hover:text-purple-600">{t('linkMP5')}</a>
    //     </nav>
    //     <a href="#cta" className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold bg-purple-600 text-white hover:bg-purple-700 transition">
    //       {t('ButtonOLBP1')}
    //     </a>
    //     <ProductMenu />
    //     <LanguageSwitcher />
    //   </Container>
    // </header>
  );
}

/* ===================== HERO ===================== */
function Hero() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" aria-hidden>
        <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-purple-100 blur-3xl opacity-60" />
        <div className="absolute -left-24 -bottom-24 h-64 w-64 rounded-full bg-indigo-100 blur-3xl opacity-60" />
      </div>

      <Container className="py-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-xs text-gray-600 mb-4">
              <span className="inline-block h-2 w-2 rounded-full bg-purple-600" /> {t('Subheader38')}
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight">
              <Trans
              i18nKey="Header33"
              components={{ span: <span className="text-transparent bg-clip-text" style={{ background: "linear-gradient(90deg,#7c3aed,#4f46e5)", WebkitTextFillColor: "transparent", backgroundClip: "text" }}/> }}
              />
            </h1>
            <p className="mt-4 text-lg text-gray-700">
              <Trans 
              i18nKey="Subheader39"
              components={{ strong: <strong /> }}
              />
            </p>
            <ul className="mt-6 grid sm:grid-cols-3 gap-3 text-sm text-gray-800">
              <Li>{t('Subheader391')}</Li>
              <Li>{t('Subheader392')}</Li>
              <Li>{t('Subheader393')}</Li>
            </ul>
            <div className="mt-8 flex flex-col sm:flex-row gap-3" id="cta">
              <a href="#pricing" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-purple-600 text-white hover:bg-purple-700 transition shadow-sm">
                {t('ButtonOLBP2')}
              </a>
              <a href="#program" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">
                {t('ButtonOLBP3')}
              </a>
            </div>
            <p className="mt-3 text-xs text-gray-600">{t('Subheader40')}</p>
          </div>

          <div className="relative">
            <Card className="shadow-[0_6px_28px_rgba(0,0,0,.06)]">
              <div className="grid grid-cols-3 gap-4">
                <div className="rounded-2xl bg-gray-50 p-4 text-center">
                  <div className="text-[18px] font-bold">12</div>
                  <div className="mt-1 text-xs text-gray-600">{t('OLBP_ExRes11')}</div>
                </div>
                <div className="rounded-2xl bg-gray-50 p-4 text-center">
                  <div className="text-[18px] font-bold">24/7</div>
                  <div className="mt-1 text-xs text-gray-600">{t('OLBP_ExRes21')}</div>
                </div>
                <div className="rounded-2xl bg-gray-50 p-4 text-center">
                  <div className="text-[14px] font-bold">{t('OLBP_ExRes3')}</div>
                  <div className="mt-1 text-xs text-gray-600">{t('OLBP_ExRes31')}</div>
                </div>
              </div>
              <Pill className="mt-6">
                <div className="text-sm opacity-90">{t('Header341')}</div>
                <div className="text-3xl font-extrabold tracking-tight">{t('Header34')}</div>
              </Pill>
            </Card>
          </div>
        </div>
      </Container>
    </section>
  );
}


/* ===================== PROOF ===================== */
function Proof() {
  const { t } = useTranslation();
  return (
    <section id="proof">
      <Container>
        <div className="rounded-3xl border border-gray-200 bg-gradient-to-r from-purple-50 to-indigo-50 p-6 md:p-8">
          <div className="grid md:grid-cols-2 gap-6 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-extrabold text-gray-900">{t('Header35')}</h2>
              <p className="mt-2 text-gray-700">
                {t('Subheader351')}
              </p>
              <ul className="mt-4 text-sm text-gray-800 space-y-2">
                <Li>{t('Subheader3511')}</Li>
                <Li>{t('Subheader3512')}</Li>
                <Li>{t('Subheader3513')}</Li>
              </ul>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-3 gap-4">
                <div key={0} className="bg-white/70 rounded-lg border border-gray-200 flex flex-col items-center justify-center text-xs text-gray-500 p-4">
                  <p>
                    ***
                  </p>
                  <p className="text-center">
                    {t('Subheader3521')}
                  </p>
                </div>
                <div key={1} className="bg-white/70 rounded-lg border border-gray-200 flex flex-col items-center justify-center text-xs text-gray-500 p-4">
                  <p>
                    ***
                  </p>
                  <p className="text-center">
                    {t('Subheader3522')}
                  </p>
                </div>
                <div key={2} className="bg-white/70 rounded-lg border border-gray-200 flex flex-col items-center justify-center text-xs text-gray-500 p-4">
                  <p>
                    ***
                  </p>
                  <p className="text-center">
                    {t('Subheader3523')}
                  </p>
                </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

/* ===================== BENEFITS ===================== */
function Benefits() {
  const { t } = useTranslation();
  return (
    <section id="benefits">
      <Container className="py-12">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header36')}</h2>
        <div className="mt-6 grid lg:grid-cols-3 gap-4">
          {[
            {
              title: t('Subheader361'),
              big: t('Subheader361'),
              subtitle: t('Subheader3611'),
              text: t('Subheader36111'),
            },
            {
              title: t('Subheader362'),
              big: t('Subheader362'),
              subtitle: t('Subheader3621'),
              text: t('Subheader36211'),
            },
            {
              title: t('Subheader363'),
              big: t('Subheader363'),
              subtitle: t('Subheader3631'),
              text: t('Subheader36311'),
            },
          ].map((b) => (
            <Card key={b.title}>
              <div className="text-4xl font-extrabold text-purple-600">{b.big}</div>
              <h3 className="mt-2 text-lg font-semibold">{b.subtitle}</h3>
              <p className="mt-1 text-sm text-gray-600">{b.text}</p>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}

/* ===================== PROGRAM ===================== */
function Program() {
  const { t } = useTranslation();
  const modules = [
  [t('OLBPTraining1'), t('OLBPTraining1a')],
  [t('OLBPTraining2'), t('OLBPTraining2a')],
  [t('OLBPTraining3'), t('OLBPTraining3a')],
  [t('OLBPTraining4'), t('OLBPTraining4a')],
  [t('OLBPTraining5'), t('OLBPTraining5a')],
  [t('OLBPTraining6'), t('OLBPTraining6a')],
  [t('OLBPTraining7'), t('OLBPTraining7a')],
  [t('OLBPTraining8'), t('OLBPTraining8a')],
  [t('OLBPTraining9'), t('OLBPTraining9a')],
  [t('OLBPTraining10'), t('OLBPTraining10a')],
  [t('OLBPTraining11'), t('OLBPTraining11a')],
  [t('OLBPTraining12'), t('OLBPTraining12a')],
];


  return (
    <section id="program">
      <Container>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header37')}</h2>
        <p className="mt-3 text-gray-600">
          {t('Subheader371')}
        </p>
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          {modules.map((m) => (
            <details key={m[0]} className="rounded-2xl border border-gray-200 bg-white p-4 open:shadow-[0_6px_28px_rgba(0,0,0,.06)]">
              <summary className="cursor-pointer font-semibold">{m[0]}</summary>
              <div className="mt-2 text-sm text-gray-700">
                {m[1]}<span className="font-medium">{m[2]}</span>{m[3]}
                {m[4] && (<><span className="font-medium">{m[4]}</span>{m[5]}</>)}
              </div>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}

/* ===================== ACTION BLOCK ===================== */
function ActionBlock() {
  const { t } = useTranslation();
  return (
    <section>
      <Container className="py-12">
        <Card className="md:p-8">
          <div className="grid md:grid-cols-2 gap-6 items-start">
            <div>
              <h2 className="text-2xl font-bold tracking-tight">{t('Header38')}</h2>
              <p className="mt-2 text-gray-700">
                <Trans 
                i18nKey="Subheader381"
                components={{ strong: <strong /> }}
                />
              </p>
              <ul className="mt-4 text-sm text-gray-700 space-y-2">
                <Li>{t('Subheader381a')}</Li>
                <Li>{t('Subheader381b')}</Li>
                <Li>{t('Subheader381c')}</Li>
              </ul>
            </div>
            <Pill>
              <div className="text-sm opacity-90">{t('OLBPSteps')}</div>
              <ol className="mt-2 list-decimal pl-5 space-y-1 text-white/95">
                <li>{t('OLBPSteps1')}</li>
                <li>{t('OLBPSteps2')}</li>
                <li>{t('OLBPSteps3')}</li>
                <li>{t('OLBPSteps4')}</li>
                <li>{t('OLBPSteps5')}</li>
              </ol>
            </Pill>
          </div>
        </Card>
      </Container>
    </section>
  );
}

/* ===================== INSTRUCTOR ===================== */
function Instructor() {
  const { t } = useTranslation();
  return (
    <section id="instructor">
      <Container className="pb-6">
        <Card className="md:p-8">
          <div className="grid md:grid-cols-3 gap-6 items-center">
            <div className="md:col-span-2">
              <h3 className="text-xl md:text-2xl font-bold tracking-tight">{t('Header39')}</h3>
              <p className="mt-2 text-gray-700">{t('Subheader39a')}</p>
              <ul className="mt-4 text-sm text-gray-700 space-y-2">
                <Li>{t('Subheader39a1')}</Li>
                <Li>{t('Subheader39a2')}</Li>
                <Li>{t('Subheader39a3')}</Li>
              </ul>
            </div>
            <div className="w-full h-full">
              <a href="/about">
              <img src={aboutImg} className="rounded-2xl" />
              </a>
            </div>
          </div>
        </Card>
      </Container>
    </section>
  );
}

/* ===================== TESTIMONIALS ===================== */
function Testimonials() {
  const { t } = useTranslation();
  const quotes = [
    [t('OLBPReview1'), t('OLBPReview1a')],
    [t('OLBPReview2'), t('OLBPReview2a')],
    [t('OLBPReview3'), t('OLBPReview3a')],
  ];
  return (
    <section>
      <Container className="pb-6">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header40')}</h2>
        <div className="mt-6 grid md:grid-cols-3 gap-4">
          {quotes.map(([q, a]) => (
            <Card key={q}>
              <p className="text-sm text-gray-700">{q}</p>
              <div className="mt-3 text-xs text-gray-500">{a}</div>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}

/* ===================== PRICING ===================== */
function Pricing() {
  const { t } = useTranslation();

  const plans = [
  {
    name: t('OLBPTarif1'),
    price: "17 800 ₽",
    note: t('OLBPTarif1a'),
    features: [
      t('OLBPTarif1b'),
      t('OLBPTarif1c'),
    ],
    cta: t('ButtonOLBP5'),
  },
  {
    name: t('OLBPTarif2'),
    price: "157 990 ₽",
    note: "",
    features: [
      t('OLBPTarif2a'),
      t('OLBPTarif2b')
    ],
    cta: t('ButtonOLBP5'),
    recommended: true,
  },
  {
    name: t('OLBPTarif3'),
    price: "",
    note: "",
    features: [
    ],
    cta: t('ButtonOLBP6'),
    corporate: true,
  },
];


  return (
    <section id="pricing">
      <Container className="py-12">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header41')}</h2>
        <p className="mt-2 text-gray-600">{t('Subheader411')}</p>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {plans.map((p) => (
            <Card key={p.name} className={`flex flex-col ${p.recommended ? "border-2 border-purple-600 relative" : ""} ${p.corporate ? "justify-center items-center" : ""}`}>
              {p.recommended && (
                <div className="absolute -top-3 right-4 text-[10px] px-2 py-1 rounded-full bg-purple-600 text-white">{t('Subheader281')}</div>
              )}
              <h3 className={`text-lg font-semibold ${p.corporate ? "mt-auto" : ""}`}>{p.name}</h3>
              {!p.corporate && (
                <div>
                  <div className="mt-2 text-3xl font-extrabold">{p.price}</div>
                  <p className="mt-1 text-sm text-gray-600">{p.note}</p>
                  <ul className="mt-4 text-sm text-gray-700 space-y-2 flex-1">
                    {p.features.map((f) => (
                      <Li key={f}>{f}</Li>
                    ))}
                  </ul>
                </div>
              )}
              <a href={p.corporate ? "mailto:info@best-practices.online" : "https://best-practices.zenclass.ru/school/products"} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center justify-center rounded-2xl px-5 py-3 text-base font-semibold bg-purple-600 text-white hover:bg-purple-700 transition w-full">{p.cta}</a>
            </Card>
          ))}
        </div>
        <p className="mt-3 text-xs text-gray-500">{t('OLBPTarifGeneralRef')}</p>
      </Container>
    </section>
  );
}

/* ===================== CTA BAR ===================== */
function CtaBar() {
  const { t } = useTranslation();
  return (
    <section>
      <Container className="pb-12">
        <div className="rounded-3xl border border-gray-200 bg-white p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight">{t('Header42')}</h3>
            <p className="mt-1 text-gray-600">{t('Subheader421')}</p>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <a href="#pricing" className="inline-flex flex-1 md:flex-none items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-purple-600 text-white hover:bg-purple-700 transition shadow-sm">{t('ButtonOLBP7')}</a>
            <a href="#program" className="inline-flex flex-1 md:flex-none items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">{t('ButtonOLBP8')}</a>
          </div>
        </div>
      </Container>
    </section>
  );
}

/* ===================== {t('linkMP5')} ===================== */
function Faq() {
  const { t } = useTranslation();
  const qna = [
  [t('OLBP_FAQ1'), t('OLBP_FAQ1a')],
  [t('OLBP_FAQ2'), t('OLBP_FAQ2a')],
  [t('OLBP_FAQ3'), t('OLBP_FAQ3a')],
  [t('OLBP_FAQ4'), t('OLBP_FAQ4a')],
];

  return (
    <section id="faq">
      <Container className="pb-16">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header43')}</h2>
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          {qna.map(([q, a]) => (
            <details key={q} className="rounded-2xl border border-gray-200 bg-white p-4 open:shadow-[0_6px_28px_rgba(0,0,0,.06)]">
              <summary className="cursor-pointer font-semibold">{q}</summary>
              <div className="mt-2 text-sm text-gray-700">{a}</div>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}

/* ===================== FOOTER ===================== */
function Footer({ year }) {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-gray-100">
      <Container className="py-8 text-sm text-gray-500 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>© {year} {t('RBP_GenRef')}</div>
        <div className="flex gap-6">
          <a className="hover:text-gray-700" href="https://best-practices.online/" target="_blank" rel="noopener noreferrer">Сайт</a>
          <a className="hover:text-gray-700" href="https://best-practices.zenclass.ru/" target="_blank" rel="noopener noreferrer">{t('linkOLBP5')}</a>
          <a className="hover:text-gray-700" href="#">{t('linkOLBP6')}</a>
        </div>
      </Container>
    </footer>
  );
}